import { Link } from 'react-router-dom';

export default function DualitySection() {
  return (
    <section className="relative bg-[#0A0A0A] py-24 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="fade-in-up text-center mb-16">
          <p
            className="text-[#4D1815] text-xs mb-4"
            style={{ letterSpacing: '0.5em', fontFamily: "'Cormorant Garamond', serif" }}
          >
            — THE PRODUCT —
          </p>
          <h2
            className="text-[#EADDCC] font-light"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(32px, 5vw, 64px)',
              letterSpacing: '0.1em',
            }}
          >
            Wild. Luxurious. <em className="italic text-[#EADDCC]/60">Unapologetic.</em>
          </h2>
        </div>

        {/* Single full-width image + side text layout */}
        <div className="fade-in-up flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

          {/* Image */}
          <div className="hover-zoom relative overflow-hidden w-full lg:w-3/5 flex-shrink-0" style={{ height: '560px' }}>
            <img
              src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/fe16b5171ca09a17bb581d1bce10579e.png"
              alt="Gucci Beauty Lipstick — The Beast Within"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            {/* Bottom label */}
            <div className="absolute bottom-8 left-8 right-8 flex items-end justify-between">
              <span
                className="text-[#EADDCC] text-xl font-light"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.2em' }}
              >
                WILD
              </span>
              <span
                className="text-[#4D1815] text-xs"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.3em' }}
              >
                ×
              </span>
              <span
                className="text-[#EADDCC]/60 text-xl font-light italic"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.2em' }}
              >
                LUXURY
              </span>
            </div>
          </div>

          {/* Text block */}
          <div className="flex-1 flex flex-col gap-8">
            <div className="border-t border-[#EADDCC]/10 pt-8">
              <p
                className="text-[#4D1815] text-xs mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.4em' }}
              >
                01 — THE OBJECT
              </p>
              <p
                className="text-[#EADDCC]/70 font-light leading-relaxed"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '17px', lineHeight: 2 }}
              >
                Three lipsticks. One truth.
                The beast leaves its mark in deep wine red.
              </p>
            </div>

            <div className="border-t border-[#EADDCC]/10 pt-8">
              <p
                className="text-[#4D1815] text-xs mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.4em' }}
              >
                02 — THE TENSION
              </p>
              <p
                className="text-[#EADDCC]/70 font-light leading-relaxed"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '17px', lineHeight: 2 }}
              >
                Tiger stripe against gold casing —
                the untamed housed in the exquisite.
              </p>
            </div>

            <div className="border-t border-[#EADDCC]/10 pt-8">
              <p
                className="text-[#4D1815] text-xs mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.4em' }}
              >
                03 — THE STATEMENT
              </p>
              <p
                className="text-[#EADDCC]/70 font-light leading-relaxed"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '17px', lineHeight: 2 }}
              >
                To wear it is not decoration.
                It is declaration.
              </p>
            </div>

            <div className="pt-4">
              <Link
                to="/campaign-concept"
                className="group inline-flex items-center gap-4 text-[#EADDCC]/50 text-xs tracking-widest cursor-pointer hover:text-[#EADDCC] transition-colors duration-300 whitespace-nowrap"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.3em' }}
              >
                EXPLORE THE CAMPAIGN
                <span className="w-8 h-px bg-current transition-all duration-300 group-hover:w-16" />
              </Link>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
